'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var withStyles = {};

exports.__exports = withStyles;
